export default __webpack_public_path__ + "static/preschool1-ae505d7ecdd56dc84a0479bc6d69300f.jpg";